module.exports = __webpack_public_path__ + "static/media/Driver Trainings IDTR.7a428b6f.csv";